import { createReducer } from 'reduxsauce'
import {
  CLEAR_SETTINGS,
  SETTING_ADDED,
  UPDATE_LAST_SETTING,
  UPDATE_SETTINGS_IDS,
  UPDATE_CURRENT_SETTING_ID,
  APPLY_ADJUST,
  SET_IMAGE_STATUS,
  REMOVE_LAST_SETTING,
  TOGGLE_SHOULD_CONFIRM_REVERT,
} from '../types/settings.types'

export const INITIAL_STATE = {
  settingsList: [],
  currentSettingId: 0,
  settingLimitId: 0,
  lastSettingId: 0,
  brightnessApplied: false,
  contrastApplied: false,
  saturationApplied: false,
  imageStatus: false,
  shouldConfirmRevert: false,
}

export const clearSettings = (state = INITIAL_STATE) => ({
  ...state,
  settingsList: [],
  currentSettingId: 0,
  settingLimitId: 0,
  lastSettingId: 0,
  imageStatus: false,
})
export const settingAdded = (state = INITIAL_STATE, { payload: setting }) => ({
  ...state,
  settingsList: [...state.settingsList.filter((setting) => setting.id < state.currentSettingId), setting],
})
export const updateLastSetting = (state = INITIAL_STATE, { payload: setting }) => ({
  ...state,
  settingsList: [...state.settingsList.slice(0, state.settingsList.length - 1), setting],
})
export const removeLastSetting = (state = INITIAL_STATE) => ({
  ...state,
  settingsList: state.settingsList.slice(0, -1),
  lastSettingId: state.lastSettingId - 1,
  currentSettingId: state.currentSettingId === state.lastSettingId ? state.currentSettingId - 1 : state.currentSettingId
})
export const updateSettingsIds = (state = INITIAL_STATE, { payload: id }) => ({
  ...state,
  currentSettingId: id,
  settingLimitId: id - state.settingLimitId < 10 ? state.settingLimitId : id - 10,
  lastSettingId: id,
  imageStatus: true,
})

export const updateCurrentSettingId = (state = INITIAL_STATE, { payload: id }) => ({
  ...state,
  currentSettingId: id,
  imageStatus: true,
})
export const applyAdjust = (state = INITIAL_STATE, { payload: name }) => ({ ...state, [`${name}Applied`]: true })
export const setImageStatus = (state = INITIAL_STATE) => ({ ...state, imageStatus: false })

export const toggleShouldConfirmRevert = (state = INITIAL_STATE) => ({
  ...state,
  shouldConfirmRevert: !state.shouldConfirmRevert,
})

export const HANDLERS = {
  [CLEAR_SETTINGS]: clearSettings,
  [SETTING_ADDED]: settingAdded,
  [UPDATE_LAST_SETTING]: updateLastSetting,
  [REMOVE_LAST_SETTING]: removeLastSetting,
  [UPDATE_SETTINGS_IDS]: updateSettingsIds,
  [UPDATE_CURRENT_SETTING_ID]: updateCurrentSettingId,
  [APPLY_ADJUST]: applyAdjust,
  [SET_IMAGE_STATUS]: setImageStatus,
  [TOGGLE_SHOULD_CONFIRM_REVERT]: toggleShouldConfirmRevert,
}

export default createReducer(INITIAL_STATE, HANDLERS)
